import axios from "axios";

export default async function ActiveSite() {
  try {
    const response = await axios.get("https://api.palinagyonbuzi.com/api/site");

    const logo = response.data.logo;
    const desc = response.data.overlay_desc;
    const site = { logo, desc };
    console.log("Active site data: ", site);

    return site;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
